import { ConfigurationData, IConfigurationData } from "data";
import { IConfiguration } from "interfaces";
import { OptionType } from "types";

export interface IConfigurationService {
  all(): Promise<IConfiguration[]>;
  asPairValue(): Promise<OptionType[]>;
}

export class ConfigurationService implements IConfigurationService {
  ConfigurationData: IConfigurationData;

  constructor() {
    this.ConfigurationData = new ConfigurationData();
  }

  /**
   * fetch all the Configurations
   * @returns {IConfiguration[]} a list of Configurations
   */

  async all() {
    const { payload: response } = await this.ConfigurationData.all();
    return response.sort((a, b) => a.name.localeCompare(b.name));
  }

  /**
   * fetch all the Configurations as OptionType array
   * @returns {OptionType[]} a list of Configurations
   */

  async asPairValue() {
    return (await this.all()).map((item: IConfiguration) => ({ value: item._id, label: item.name } as OptionType)) as OptionType[];
  }
}